"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAdvancedDiscountApplicable = exports.getDiscountQuantity = exports.getProductCategoriesCount = void 0;
const domain_1 = require("@oolio-group/domain");
const getCategoryId = (item) => {
    var _a, _b, _c;
    return item ? ((_a = item.product.category) === null || _a === void 0 ? void 0 : _a.id) || ((_c = (_b = item.variant) === null || _b === void 0 ? void 0 : _b.category) === null || _c === void 0 ? void 0 : _c.id) : '';
};
/**
 *
 * @param discount discount for which we're checking the items
 * @param groupByCategories
 * @param groupByProducts
 * @returns This function will return the quantity which we can apply for each discount
 *          it wll include both how much quantity we can apply for purchased rule and discount rule
 */
const getProductCategoriesCount = (discount, groupByCategories, groupByProducts) => {
    var _a, _b, _c, _d, _e;
    const { productIds: purchasedProductIds = [], categoryIds: purchasedCategoryIds = [], qty: purchasedQty = 0, } = ((_a = discount.advanceRules) === null || _a === void 0 ? void 0 : _a.purchasedCriteria) || {};
    const { productIds: discountedProductIds = [], categoryIds: discountedCategoryIds = [], qty: discountedQty = 0, } = ((_b = discount.advanceRules) === null || _b === void 0 ? void 0 : _b.discountedCriteria) || {};
    const totalQty = purchasedQty + discountedQty;
    const allItems = (_e = (_d = (_c = Object.values(groupByCategories)) === null || _c === void 0 ? void 0 : _c.map(e => e.items)) === null || _d === void 0 ? void 0 : _d.flat()) !== null && _e !== void 0 ? _e : [];
    const filteredPurchasedProductIds = (purchasedProductIds === null || purchasedProductIds === void 0 ? void 0 : purchasedProductIds.filter(productId => {
        var _a, _b;
        const productCategoryId = getCategoryId((_b = (_a = groupByProducts[productId]) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b[0]);
        if (purchasedCategoryIds === null || purchasedCategoryIds === void 0 ? void 0 : purchasedCategoryIds.includes(productCategoryId))
            return false;
        else
            return true;
    })) || [];
    const filteredDiscountedProductIds = (discountedProductIds === null || discountedProductIds === void 0 ? void 0 : discountedProductIds.filter(productId => {
        var _a, _b;
        const productCategoryId = getCategoryId((_b = (_a = groupByProducts[productId]) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b[0]);
        if (discountedCategoryIds === null || discountedCategoryIds === void 0 ? void 0 : discountedCategoryIds.includes(productCategoryId))
            return false;
        else
            return true;
    })) || [];
    let totalPurchasedQty = [
        ...(purchasedCategoryIds !== null && purchasedCategoryIds !== void 0 ? purchasedCategoryIds : []),
        ...filteredPurchasedProductIds,
    ].reduce((count, id) => {
        var _a, _b;
        return count +
            (((_a = groupByCategories[id]) === null || _a === void 0 ? void 0 : _a.quantityCount) ||
                ((_b = groupByProducts[id]) === null || _b === void 0 ? void 0 : _b.quantityCount) ||
                0);
    }, 0);
    let totalDiscountedQty = [
        ...(discountedCategoryIds !== null && discountedCategoryIds !== void 0 ? discountedCategoryIds : []),
        ...filteredDiscountedProductIds,
    ].reduce((count, id) => {
        var _a, _b;
        return count +
            (((_a = groupByCategories[id]) === null || _a === void 0 ? void 0 : _a.quantityCount) ||
                ((_b = groupByProducts[id]) === null || _b === void 0 ? void 0 : _b.quantityCount) ||
                0);
    }, 0);
    const processedItemIds = [];
    /*
    Finding overlap qty which can present in both
    This should used while finding the purchase and discount qty to apply
    */
    const overlapTotalQty = allItems.reduce((count, item) => {
        const itemProductId = item.product.id;
        const itemCategoryId = getCategoryId(item);
        if (!processedItemIds.includes(itemProductId) &&
            !processedItemIds.includes(itemCategoryId)) {
            if ((purchasedProductIds === null || purchasedProductIds === void 0 ? void 0 : purchasedProductIds.includes(itemProductId)) &&
                (discountedProductIds === null || discountedProductIds === void 0 ? void 0 : discountedProductIds.includes(itemProductId))) {
                count += groupByProducts[itemProductId].quantityCount;
                processedItemIds.push(itemProductId);
            }
            else if ((purchasedCategoryIds === null || purchasedCategoryIds === void 0 ? void 0 : purchasedCategoryIds.includes(itemCategoryId)) &&
                (discountedCategoryIds === null || discountedCategoryIds === void 0 ? void 0 : discountedCategoryIds.includes(itemCategoryId))) {
                count += groupByCategories[itemCategoryId].quantityCount;
                processedItemIds.push(itemCategoryId);
            }
            else if (((purchasedProductIds === null || purchasedProductIds === void 0 ? void 0 : purchasedProductIds.includes(itemProductId)) &&
                (discountedCategoryIds === null || discountedCategoryIds === void 0 ? void 0 : discountedCategoryIds.includes(itemCategoryId))) ||
                ((discountedProductIds === null || discountedProductIds === void 0 ? void 0 : discountedProductIds.includes(itemProductId)) &&
                    (purchasedCategoryIds === null || purchasedCategoryIds === void 0 ? void 0 : purchasedCategoryIds.includes(itemCategoryId)))) {
                count += groupByProducts[itemProductId].quantityCount;
                processedItemIds.push(itemProductId);
            }
        }
        return count;
    }, 0);
    const availableCartQty = totalPurchasedQty + totalDiscountedQty - overlapTotalQty;
    if (overlapTotalQty) {
        // Rule is not matched so no discount would applied
        if (availableCartQty < totalQty) {
            totalPurchasedQty = availableCartQty;
            totalDiscountedQty = 0;
        }
        else {
            //Here we need to find how much maximum discount we can apply on discounted qty
            const maxDiscountNumber = Math.floor(availableCartQty / totalQty);
            const discountQtyToApply = maxDiscountNumber * discountedQty;
            const maxDiscountCanApply = Math.floor(totalPurchasedQty / purchasedQty) * discountedQty;
            totalDiscountedQty =
                discountQtyToApply > maxDiscountCanApply
                    ? maxDiscountCanApply
                    : discountQtyToApply;
            totalPurchasedQty = availableCartQty - totalDiscountedQty; // Need to change this logic
        }
    }
    return {
        purchasedItemsQtyCount: totalPurchasedQty,
        discountedItemsQtyCount: totalDiscountedQty,
    };
};
exports.getProductCategoriesCount = getProductCategoriesCount;
/**
 *
 * @param discount discount to apply
 * @param qty to add for discount if flat discount was there
 * @returns total quantity to returns
 */
const getDiscountQuantity = (discount, qty) => {
    const isFlatDiscount = (discount === null || discount === void 0 ? void 0 : discount.adjustmentUnit) === domain_1.AdjustmentUnit.FLAT;
    return isFlatDiscount ? qty : undefined;
};
exports.getDiscountQuantity = getDiscountQuantity;
const isAdvancedDiscountApplicable = (appliedDiscount, highestDiscount, itemId, adjustmentByOrderItem) => {
    return (!adjustmentByOrderItem[itemId] &&
        (!appliedDiscount ||
            ((appliedDiscount === null || appliedDiscount === void 0 ? void 0 : appliedDiscount.id) !== highestDiscount.id &&
                appliedDiscount.isDiscountRuleEnabled)));
};
exports.isAdvancedDiscountApplicable = isAdvancedDiscountApplicable;
//# sourceMappingURL=common.js.map